import request from '@/plugin/axios'
//上传公共方法
export function uploadFile(params) {
    return request({
        url: '/api/admin/sysFiles/uploadContractEnclosure',
        method: 'post',
        headers: {'Content-Type': 'multipart/form-data'},
        data: params
    });
}